import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes"
import { FetchRequestActions } from "../../../../utils/request-actions-helpers/createRequestActions"
import { ApiConfig } from "../../../../config/ApiConfig"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk"
import { DocumentDataType } from "../../../../models/Document"

export type CustomInputMappingFieldType = "paragraph" | "text" | "select" | "multiSelect" | "date" | "dateTime" | "number" | "location" | "title" | "datatype" | "barcode" | "signature" | 'businessId' | "email" | "phone" | 'article' | 'calculation'

export interface CustomInputMappingField {
    toAggregate: boolean
    sourceField: string
    aggregateField: string
    fieldName: string
    fieldDescription: string | null
    fieldIcon: string | null
    unit: string
    type: CustomInputMappingFieldType
    dataType: DocumentDataType | null
    options: string | null
    fieldOrder?: number
    required?: boolean
    automaticTitleOrder?: number
    previewDisplayOrder?: number
    conditionField?: string
    conditionValue?: string
}

export interface CustomInputMapping {
    title: string
    icon: string,
    customDataMapping: {
        id?: number
        dataTypeFilter: string
        customFieldsMappings: CustomInputMappingField[]
        structureJson: string
    },
    enablePublishingToPublicFeed: boolean
    isEveryoneCanEdit: boolean
    isEnableLocation: boolean
    isAutomaticTitle: boolean
    isWithoutSeparateTitleByCommas?: boolean
    isEnableFiles: boolean
    isEnableLinks?: boolean | null
    isEnableRating: boolean
    isEnableDueDate: boolean
    isDueDateMandatory: boolean
    isRtl?: boolean
    isBusinessIdEnabled?: boolean
    defaultCollectionUid?: string | null
    specificGroupsUids?: string | null
    isAutomaticBusinessId?: boolean
}

export const fetchCustomInputMappingsActionTypes = createRequestActionTypes('CUSTOM_INPUT_MAPPINGS')

export type CustomInputMappingActions = FetchRequestActions<CustomInputMapping[]>

export const fetchCustomInputMappings = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<CustomInputMapping[]> = {
        method: 'GET',
        requestActionTypes: fetchCustomInputMappingsActionTypes,
        url: `${config.API_URL}/custominput`,
    }
    return createRequestThunk(thunkParams)
}